import { preLoadImage } from "../redux/actions/image";

export function generateRandomCode() {
  let randomNumber = Math.floor(Math.random() * 10000);

  let paddedNumber = randomNumber.toString().padStart(4, "0");

  return paddedNumber;
}

export const isValidArray = (data) => {
  return data && Array.isArray(data) && data.length > 0;
};

export const isValidEmail = (email) => {
  var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return pattern.test(email);
};

export const nextPageRoute = async (
  routeFunc,
  route,
  dispatch = null,
  imagesToPreload = []
) => {
  const start = Date.now();

  if (isValidArray(imagesToPreload) && dispatch) {
    dispatch(preLoadImage(imagesToPreload));
  }

  const elapsed = Date.now() - start;
  const delay = Math.max(0, 250 - elapsed);

  setTimeout(() => {
    routeFunc(route);
  }, delay);
};

export const getApiData = (data) => {
  const newData = data?.data?.responseData ?? data?.data ?? data ?? null;
  return newData;
};

export const addS3Url = (url) => {
  return `${process.env.REACT_APP_S3_URL}${url}`;
};

export const checkGender = (item) => {
  if (!item) {
    return false;
  } else if (item == "undefined") {
    return false;
  }
  return item;
};
